export const FAILURE_STATUS = 'FAILURE';
export const SUCCESS_STATUS = 'SUCCESS';
export const GOOGLE_WEB_CLIENT = '1070155476503-mkr20jqrk8u8a0162sdqtkedisgbgun5.apps.googleusercontent.com';
export const GOOGLE_IOS_CLIENT = '1070155476503-d2oi0k7btdv90jjrfp47m3f80q7pplth.apps.googleusercontent.com';
